import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CreateChannelModal from '../CreateChannelModal';
import BroadcastType from './BroadcastType';
import { Typography, colors, TextInput } from 'kangarootime-ui';

const NewBroadcastModal = ({
  isOpen,
  onClose,
  currentCenterId,
  currentCenterName,
  existingChannels,
  employeeLegacyChatId,
  existingBroadcasts,
  ...props
}) => {
  const [broadcastTitle, setBroadcastTitle] = useState('');
  const [broadcastType, setBroadcastType] = useState('center');
  const hasBroadcasts = existingBroadcasts.length > 0;
  // check to see if the selected center already has a center-wide broadcast (only 1 center-wide broadcast is allowed per center)
  const selectedCenterAlreadyHasCenterBroadcast = hasBroadcasts && existingBroadcasts.some(channel => channel.broadcastType.match(/center/) && `${channel.broadcastTypeId}` === `${currentCenterId}`);
  const centerTypeSelected = broadcastType.match(/center/i);
  const programTypeSelected = broadcastType.match(/program/i);
  const broadcastTypeId = centerTypeSelected ? currentCenterId : '';
  // Note: group-specific is part of the next iteration
  const createChannelButtonDisabled = selectedCenterAlreadyHasCenterBroadcast || broadcastTitle.trim().length === 0 || programTypeSelected;

  return (
    <CreateChannelModal
      isOpen={isOpen}
      onClose={onClose}
      title='Create a Broadcast'
      subtitle='Broadcasts allow you to quickly message all or a subset of your parents at once. Broadcast messages can only be written by Managers and are read-only for recipients.'
      buttonText='Create Broadcast'
      buttonDisabled={createChannelButtonDisabled}
      newChannelDetails={{
        name: broadcastTitle,
        topic: '',
        centerId: `${currentCenterId}`,
        private: false,
        directMessage: false,
        broadcastType,
        broadcastTypeId,
        invitedUserIds: []
      }}
      employeeLegacyChatId={employeeLegacyChatId}
    >
      <Typography style={{ marginTop: 8 }}>What type of broadcast would you like to create?</Typography>
      { centerTypeSelected
        ? <Typography type='meta'>A center-wide broadcast will add all parents at your center to this channel.</Typography>
        : <Typography type='meta'>A program-specific broadcast will add all parents with children in the selected program to this channel.</Typography>
      }
      <BroadcastType selectedValue={broadcastType} onSelect={setBroadcastType} />
      { centerTypeSelected && selectedCenterAlreadyHasCenterBroadcast &&
        <Typography type='bold' style={{ color: colors.danger }}>A center-wide broadcast already exists for {currentCenterName}.</Typography>
      }
      { programTypeSelected && <Typography type='bold'>Coming soon</Typography> }
      <TextInput
        label='Name'
        helperText='This will help indicate who these messages will go to'
        placeholder={centerTypeSelected ? `${currentCenterName} Broadcast` : '[Program Name] Broadcast'}
        value={broadcastTitle}
        onChange={event => setBroadcastTitle(event.target.value)}
      />
    </CreateChannelModal>
  );
};

NewBroadcastModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  currentCenterId: PropTypes.string,
  currentCenterName: PropTypes.string,
  existingChannels: PropTypes.array,
  existingBroadcasts: PropTypes.array
};

NewBroadcastModal.defaultProps = {
  existingBroadcasts: []
};

export default NewBroadcastModal;
